// extracted by mini-css-extract-plugin
export default {"drop":"styled-dropdown_drop__UcR9h","activeOption":"styled-dropdown_activeOption__3+Ty7"};